import "./OnlineDot.scss";

const OnlineDot = `
	<span class="onlinedot" data-tooltip="Online now!" data-tooltip-padding="5"></span>
`;

export default OnlineDot;



// WEBPACK FOOTER //
// ./src/shared/components/OnlineDot.html.js